import { api } from "@/api"
import type { MerchantGroupUser } from "./types"

export const sendMerchantGroupUserLoginLink = async (
  userId: MerchantGroupUser["id"]
) =>
  await api.post(
    `/merchant-group/users/${userId}/send-login-link/`,
    { isMerchantGroup: true }
  )
